import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Gift } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { AuthShell, Field, SubmitBtn, ErrorNote } from "./AuthShell";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [referrer, setReferrer] = useState("");

  useEffect(() => {
    if (!ref) return;
    localStorage.setItem("lodge_ref", ref);
    api.get(`/referrals/lookup/${ref}`)
      .then(({ data }) => { if (data.valid) setReferrer(data.referring_org_name); })
      .catch(() => {});
  }, [ref]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      navigate("/onboarding");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Créer un compte"
      subtitle="Rejoignez Lodge & Co et créez votre organisation."
      footer={
        <>
          Vous avez déjà un compte ?{" "}
          <Link to="/login" data-testid="link-login" className="font-semibold text-[#3E7256] hover:underline">
            Se connecter
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <ErrorNote>{error}</ErrorNote>
        {referrer && (
          <div className="flex items-center gap-2.5 rounded-lg border border-[#BBD8C5] bg-[#F1F7F3] px-4 py-3" data-testid="referral-banner">
            <Gift size={18} className="flex-shrink-0 text-[#3E7256]" />
            <p className="text-sm text-[#2C5540]"><strong>{referrer}</strong> vous a invité à rejoindre Lodge & Co.</p>
          </div>
        )}
        <Field
          label="Nom complet"
          type="text"
          data-testid="register-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Camille Laurent"
          required
        />
        <Field
          label="E-mail"
          type="email"
          data-testid="register-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="vous@organisation.com"
          required
        />
        <Field
          label="Mot de passe"
          type="password"
          data-testid="register-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="6 caractères minimum"
          required
          minLength={6}
        />
        <SubmitBtn loading={loading} data-testid="register-submit">
          Créer mon compte
        </SubmitBtn>
      </form>
    </AuthShell>
  );
}
